<!--
  - SPDX-FileCopyrightText: 2023 Nextcloud GmbH and Nextcloud contributors
  - SPDX-License-Identifier: AGPL-3.0-or-later
-->

<template>
	<div class="icon-loading spinner" />
</template>

<script>
export default {

	name: 'LoadingComponent',

}
</script>
